import { defineStore } from 'pinia'
import { ref } from 'vue'



export const useStore = defineStore('main', () => {
	const active = ref(0)
	const newsList = ref('')
	
	const usList = ref({}) //联系我们
	const peopleList = ref([]) //人才战略
	
	
	return { active,newsList,usList,peopleList }
})